var React = require('react');

function PrevInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M285.59 410.4a23.93 23.93 0 0 1 0 33.84l-22.7 22.65a24 24 0 0 1-33.94 0l-154.31-154L131.42 256z","className":"secondary","key":0}),React.createElement("path",{"d":"M262.85 45.06l22.7 22.65a23.93 23.93 0 0 1 0 33.84L74.58 312.9l-40-40a23.94 23.94 0 0 1 0-33.84l194.33-194a24 24 0 0 1 33.94 0z","className":"primary","key":1})]);
}

PrevInline.defaultProps = {"viewBox":"0 0 320 512"};

module.exports = PrevInline;

PrevInline.default = PrevInline;
